import { BrowserRouter as Router } from 'react-router-dom'
import { Box, ChakraProvider, Flex } from '@chakra-ui/react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './ErrorFallback'
import theme from './theme'
import { AuthProvider } from './context/AuthContext'
import AnimatedRoutes from './AnimatedRoutes'
import Navigation from './Navigation'

function App(): JSX.Element {
  return (
    <ChakraProvider theme={theme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router>
          <AuthProvider>
            <Flex minH="100vh">
              <Navigation />
              <Box flex={1} bg="gray.900">
                <Box px={8} pt={6}>
                  <AnimatedRoutes />
                </Box>
              </Box>
            </Flex>
          </AuthProvider>
        </Router>
      </ErrorBoundary>
    </ChakraProvider>
  )
}

export default App
